export const formatPrice = (price) => {
  return new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency: 'CRC',
    minimumFractionDigits: 0
  }).format(price);
};

export const formatDuration = (duration) => {
  return duration;
};

export const calculateTotalPrice = (basePrice, vehicleMultiplier, passengers = 1) => {
  return Math.round(basePrice * vehicleMultiplier * Math.max(1, passengers / 4));
};

export const formatRating = (rating) => {
  return rating.toFixed(1);
};